import React from 'react';
import { resourcesFiles } from '../../../helpers/backend_helper';
import dayjs from 'dayjs';

const Columns = ( addUpd, destroy,setModalFile,modalFile) => {
	const getFiles = async(id) =>{
		let params={params:{relation:'sale',id:id,field:'sale_id'}}
		const response = await resourcesFiles('get',params);
		setModalFile({...modalFile,show:true,id:id,items:response.files});
	}

	let columns = [
		{
			id: 'fecha',
			name: 'Fecha',
			selector: row => dayjs(row.date.substring(0,11)).format('DD-MM-YYYY'),
			sortable: true,
			width:'15%'
		},
		{
			id: 'unit_number',
			name: 'Unidad',
			selector: row => `${row.unit_number ?? ''}`,
			sortable: true,
		},
		{
			id: 'salidas_count',
			name: 'Vueltas',
			selector: row => row.salidas_count,
			sortable: true,
		},
		{
			id: 'amount',
			name: 'Importe',
			selector: row => row.amount,
			sortable: true,
			wrap: true,

		},
		{
			id: 'notes',
			name: 'Notas',
			selector: row => row.notes,
			sortable: true,
			wrap: true,

		},
		{
			id: 'total',
			name: 'total',
			selector: row => row.total,
			sortable: true,
			wrap: true,

		},
		{
			id: 'actions',
			name: 'Acciones',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Editar venta' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="p-2">
						<button className="btn btn-danger btn-sm" title='Eliminar venta' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
		];
	return columns;
}

export default Columns;